import { prefersReducedMotion } from '../lib/lenis';

// Scroll reveals: CSS transitions + IntersectionObserver (rAF-independent, so
// content can never get stuck invisible). CSS owns the hidden/shown states
// under `html.js`; group children stagger via --reveal-delay.
export function initReveals(): void {
  const solo = Array.from(document.querySelectorAll<HTMLElement>('[data-reveal]'));
  const groups = Array.from(document.querySelectorAll<HTMLElement>('[data-reveal-group]'));
  if (!solo.length && !groups.length) return;

  const showAll = (): void => {
    solo.forEach((el) => el.classList.add('is-revealed'));
    groups.forEach((g) => Array.from(g.children).forEach((c) => c.classList.add('is-revealed')));
  };

  if (prefersReducedMotion() || !('IntersectionObserver' in window)) {
    showAll();
    return;
  }

  groups.forEach((g) => {
    Array.from(g.children).forEach((child, i) => {
      (child as HTMLElement).style.setProperty('--reveal-delay', `${(0.07 * i).toFixed(2)}s`);
    });
  });

  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const el = entry.target as HTMLElement;
        if (el.hasAttribute('data-reveal-group')) {
          Array.from(el.children).forEach((c) => c.classList.add('is-revealed'));
        } else {
          el.classList.add('is-revealed');
        }
        io.unobserve(el);
      });
    },
    { threshold: 0, rootMargin: '0px 0px -12% 0px' },
  );

  solo.forEach((el) => io.observe(el));
  groups.forEach((g) => io.observe(g));
}
